module.exports = __webpack_public_path__ + "img/logo-hen.66daec85.png";